import React from 'react';
import { FoodPhoto } from '../FoodPhoto';
export function FoodPhoto1() {
  return <FoodPhoto src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200&q=85" alt="Colorful fresh salad bowl with grilled chicken and vegetables" caption="High-protein salad with grilled chicken, avocado, and roasted vegetables" data-id="element-220" />;
}